import 'react-app-polyfill/ie11';
import React from 'react';
import * as styled from 'styled-components';
import ReactDOM from 'react-dom';
import App from './App';

import configureStore from './store/configureStore';

const store = configureStore();

ReactDOM.render(<App store={store} />, document.getElementById('root'));

if (window.Cypress) {
  window.store = store;
}
if ('serviceWorker' in navigator && !window.Cypress) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(
      `${process.env.PUBLIC_URL}/serviceWorker.js`
    );
  });
}

window.React = React;
window.ReactDOM = ReactDOM;
window.styled = styled;
